$buttonHeight: 32px;
$buttonWidth: 24px;

:host {
  display: inline-flex;
  width: auto;
  height: auto;
}

.remove-button {
  margin-left: calc(var(--spacer) / 2);
  margin-top: calc(var(--spacer) / 2);
}

:host([disabled]) {
  pointer-events: none;
  opacity: 0.6;
}
